module.exports = __webpack_public_path__ + "assets/b107.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b107.png
// module id = 578
// module chunks = 0